export default __webpack_public_path__ + "static/media/close.74fd12e4.svg";